<ul class="nav nav-tabs">
  @for (tab of runsheetTabs | keyvalue; track tab) {
    <li class="nav-item" (click)="changeTab(tab)">
      <a
        class="nav-link"
        data-toggle="tab"
        [ngClass]="selectedTab === tab.value ? 'active' : ''"
        >{{ tab.value }}
      </a>
    </li>
  }
</ul>
@if ([runsheetTabs.tab10, runsheetTabs.tab11].includes(selectedTab)) {
  @if (runSheetDataList?.length == 0) {
    <div class="p-2 p-lg-4">
      <div class="alert alert-warning">
        There are currently no
        {{ runsheetTabs.tab10 === selectedTab ? "scheduled" : "finished" }}
        patrols.
      </div>
    </div>
  }

  <div
    class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-5 g-3 pb-5 runsheet-content"
  >
    @for (runsheet of runSheetDataList; track runsheet; let i = $index) {
      <!-- Date Header -->
      @if (
        i === 0 ||
        (runSheetDataList[i - 1].event_date | misc: "eventDateGrouping") !==
          (runsheet?.event_date | misc: "eventDateGrouping")
      ) {
        <div class="col-12 col-md-12 col-lg-12 col-xl-12">
          <div class="p-2 fw-semibold border-bottom position-sticky top-0 z-1">
            {{ runsheet?.event_date | misc: "eventDateGrouping" }}
          </div>
        </div>
      }
      <div class="col">
        <div
          class="card bg-body-secondary cursor-pointer hover"
          [ngClass]="selectedTab === runsheetTabs?.tab11 ? 'px-2 py-3' : 'p-3'"
          (click)="openRunSheetDetailPage(runsheet)"
        >
          @if (selectedTab === runsheetTabs?.tab10) {
            @if (runsheet?.all_tasks_completed) {
              <div
                class="p-1 rounded-2 text-center fw-semibold bg-success mb-2 text-white"
              >
                Completed
              </div>
            } @else if (runsheet | misc: "runsheetInProgressCheck") {
              <div
                class="p-1 rounded-2 text-center fw-semibold bg-warning mb-2 text-dark"
              >
                In Progress
              </div>
            }
          }
          <div class="d-flex gap-2 align-items-center">
            @if (selectedTab === runsheetTabs?.tab11) {
              @if (runsheet?.all_tasks_completed) {
                <div>
                  <i
                    class="fa-solid fa-check text-success fa-2x"
                    title="Complete"
                  ></i>
                </div>
              } @else {
                <div>
                  <i
                    class="fa-solid fa-xmark text-danger fa-2x"
                    title="Incomplete"
                  ></i>
                </div>
              }
            }
            <div class="flex-grow-1">
              <div
                class="d-flex align-items-center justify-content-between gap-3"
              >
                <div class="text-break">{{ runsheet?.name }}</div>
                <div>
                  {{ selectedTab === runsheetTabs?.tab10 ? "Due" : "Finished" }}
                  <span class="fw-semibold">{{
                    runsheet?.end_datetime
                      | misc
                        : "userReadableDateTimeFormat"
                        : runsheet?.event_date
                  }}</span>
                </div>

                <!-- <div class="fw-semibold">
                  {{ runsheet?.start_time }} -
                  @if (
                    (runsheet?.event_date | misc: "eventDateGrouping") ==
                      runsheet?.end_datetime | misc: "eventDateGrouping"
                  ) {
                    {{ runsheet?.end_time }}
                  } @else {
                    {{
                      runsheet?.end_datetime
                        | misc
                          : "userReadableDateTimeFormat"
                          : runsheet?.event_date
                    }}
                  }
                </div> -->
              </div>
              <div class="d-flex align-items-center mt-2">
                <div class="flex-grow-1">
                  @if (runsheet?.assignee_id) {
                    {{ runsheet?.assignee_name }}
                  } @else {
                    <div class="text-danger fw-bold">Unassigned</div>
                  }
                </div>
                @if (addEditJob) {
                  <span
                    (click)="
                      duplicateRunSheets(runsheet);
                      $event.stopImmediatePropagation()
                    "
                  >
                    <i
                      class="fa-regular fa-copy text-secondary fs-5 me-2"
                      title="Duplicate Run Sheet"
                    ></i>
                  </span>
                }
                @if (addEditJob && runsheet | misc: "canDeleteRunSheet") {
                  <span
                    (click)="
                      openDeleteRunSheetTemplate(
                        runsheet,
                        deleteRunSheetTemplate
                      );
                      $event.stopImmediatePropagation()
                    "
                  >
                    <i
                      class="fs-5 fa-solid fa-circle-minus text-danger ms-2"
                    ></i>
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  @if (addEditJob) {
    <div class="mt-1 mx-1">
      <div class="fixed-add-btn">
        <button
          class="btn btn-primary btn-lg w-100"
          [routerLink]="['/add-runsheet']"
        >
          <span><i class="fa-solid fa-plus"></i></span>
        </button>
      </div>
    </div>
  }
} @else if (selectedTab === runsheetTabs.tab12) {
  <gtapp-scheduled-patrol-jobs></gtapp-scheduled-patrol-jobs>
}

<ng-template
  #deleteRunSheetTemplate
  let-deleteRunSheetTemplate="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="deleteRunSheetTemplate.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="alert alert-danger fw-bold text-center">
        <p>THIS ACTION CANNOT BE UNDONE!</p>
      </div>
      @if (data?.repeat_type !== "once") {
        <div class="mt-3">
          <div class="form-group ms-2 mb-5">
            <!-- Radio Group Label, if needed -->
            <div class="form-check mb-3">
              <input
                class="form-check-input"
                type="radio"
                name="deleteOption"
                id="deleteOption1"
                [value]="1"
                [(ngModel)]="deleteOptionSelected"
                [checked]="deleteOptionSelected === 1"
              />
              <label class="form-check-label" for="deleteOption1">
                Only this scheduled patrol
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="deleteOption"
                id="deleteOption2"
                [value]="2"
                [(ngModel)]="deleteOptionSelected"
                [checked]="deleteOptionSelected === 2"
                autocomplete="off"
              />
              <label class="form-check-label" for="deleteOption2">
                This and all future occurrences
              </label>
            </div>
          </div>
        </div>
      }
      @if (data?.repeat_type == "once") {
        <div>
          <div class="alert">
            Are you sure you want to delete this scheduled patrol?
          </div>
        </div>
      }
    </div>
    <div class="row row-cols-2">
      <div>
        <button
          class="btn btn-secondary btn-lg w-100"
          (click)="deleteRunSheetTemplate.close(false)"
        >
          Cancel
        </button>
      </div>
      <div>
        <button
          class="btn btn-lg btn-danger w-100"
          (click)="deleteRunSheetTemplate.close(data)"
        >
          Delete scheduled patrol
        </button>
      </div>
    </div>
  </div>
</ng-template>
